export default __webpack_public_path__ + "static/18-6e59ea92b374476e48f024c6f5690d5c.jpg";